module.exports = __webpack_public_path__ + "static/media/shop.0d6dea66.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/bottomNavigation/shop.svg
// module id = 2253
// module chunks = 0